import { useWYSIWYGContext } from '../contexts/WYSIWYGContext';
import { useHandleSelectedFile } from './useHandleSelectedFile';

export const useOnNewFileSelected = () => {
  const { loadHtmlFileInputRef } = useWYSIWYGContext();
  const handleSelectedFile = useHandleSelectedFile();

  return () => {
    const newFile = loadHtmlFileInputRef.current?.files?.[0];
    if (newFile) handleSelectedFile(newFile);
  };
};
